import React from 'react';
import PropTypes from 'prop-types';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import ContractFormService from '../services/ContractFormService';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';

class PostPaymentContractProductsListContainer extends React.Component {
  static propTypes = {
    readOnly: PropTypes.bool,
    preserveCoreProducts: PropTypes.bool,
  };

  render() {
    return (
      <PostPaymentContractProductsList
        readOnly={this.props.readOnly}
        preserveCoreProducts={this.props.preserveCoreProducts}
        onDelete={ContractFormService.productsService.handleDelete}
        onEdit={ContractFormService.productsService.handleEdit}
        data={toJS(ContractFormService.productsService.contractProducts)}
        loading={ContractFormService.fetch.fetching}
        submitting={ContractFormService.submit.fetching}
        currencyType={
          !ContractFormService.form.getValue('country') || BRAZIL.includes(ContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(PostPaymentContractProductsListContainer);
